export default __webpack_public_path__ + "static/media/app-store.6dc68a9e.svg";